import React from 'react';
import { ReactComponent as Logo } from '../../images/logo-securiti-symbol.svg';

export const SplashScreen = () => {
    return (
        <div className="c-spash-screen">
            <Logo className="brand-logo" />

            <svg className="spinner" viewBox="0 0 50 50">
                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
            </svg>
        </div>
    );
};
